import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import CustomizedRatings from "./Rating.jsx";

import * as api from "core-module/services/api";
import loadContent from "core-module/hoc/loadContent";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  ...buttonStyle
};

class SurveyModal extends Component {
  constructor() {
    super();
    this.state = {
      isSmallScreen: window.innerWidth <= 600,
      showModal: false,
      ratingOptions: [],
      existingRating: null
    };
  }

  async componentDidMount() {
    const response = await api.get(`user.${this.props.ids.user}/ratingsurvey`);
    this.setState({ ratingOptions: response?.schema?.props['rate_options']?.dropdownOptions, showModal: response?.object?.getrating, existingRating: response?.object?.rating}); 
  }

  handleConfirm = () => {
    this.postWithoutRating();
  };

  switchModalState = () => {
    this.state.showModal === true
      ? this.setState({ showModal: false })
      : this.setState({ showModal: true });
  };

  postWithoutRating = async () => {
    await api.post(`user.${this.props.ids.user}/ratingsurvey`, {
      rate: -1,
      rate_options: ""
    });
    this.switchModalState();
  };

  render() {
    const { classes } = this.props;
    const shouldAppear = this.state.showModal;
    return (
      <div>
        {shouldAppear ? (
          <SweetAlert
            style={{
              display: "block",
              top: "5%",
              minWidth: this.isSmallScreen ? "20%" : "30%",
              maxWidth: "90%",
              marginTop: "1%",
            }}
            title=""
            onConfirm={() => this.handleConfirm()}
            confirmBtnText="I don't want to answer"
            confirmBtnCssClass={classes.button + " " + classes.danger}
          >
            <h4>
              How likely are you to recommend MCSnet to a friend or colleague?
            </h4>
            <br />
            <CustomizedRatings
              user={this.props.ids.user}
              switchModalState={this.switchModalState}
              ratingOptions={this.state.ratingOptions}
              existingRating={this.state.existingRating}
            />
            <br />
            <br />
          </SweetAlert>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default withStyles(style)(loadContent("user.session", SurveyModal));
